module.exports = __webpack_public_path__ + "img/jianjietopmin.d7c86803.png";